<div class="card card-body filtros-listagem-insumos mb-3">
  <div class="row align-items-end">
    <div class="col-12 col-md-6 col-lg-4">
      <div class="form-group mb-2">
        <label>Buscar por texto</label>
        <input kendoTextBox class="form-control" placeholder="Nome ou código"
               [(ngModel)]="filtroTexto" (ngModelChange)="filtrePorTexto($event)"/>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-4">
      <div class="form-group mb-2">
        <label>Grupo</label>
        <kendo-dropdownlist class="form-control" [data]="grupos"
                            textField="nome" valueField="id" [valuePrimitive]="true"
                            [defaultItem]="{id: null, nome: 'Todos os grupos'}"
                            [(ngModel)]="grupoFiltroId" (valueChange)="filtrePorGrupo($event)">
        </kendo-dropdownlist>
      </div>
    </div>

    <div class="col-auto mb-2">
      <button type="button" class="btn btn-light" (click)="limpeFiltros()" [disabled]="!possuiFiltro()">
        <i class="fa fa-times mr-1"></i> Limpar
      </button>
    </div>
  </div>
</div>

<div class="row" *ngIf="carregando || !insumosFiltrados.length">
  <div class="card-box"  >
    <div class="categoria">
      <ng-container *ngIf="carregando">
        <i class="k-icon k-i-loading mr-1" ></i> <b>Carregando...</b>
      </ng-container>

      <div class="alert alert-info" *ngIf="!carregando">
        {{insumos.length ? 'Nenhum item encontrado para os filtros informados' : 'Nenhum item cadastrado'}}
      </div>
    </div>

  </div>
</div>



<ng-container *ngFor="let grupo of grupos">
  <div class="card" [hidden]="!carregando && !insumosPorGrupo[grupo.id]">
    <div class="categoria" >
      <h3 class="ml-2 ">
        <b> {{grupo.nome}}</b>
      </h3>
      <div class="ml-2 mb-2 text-muted"
           *ngIf="possuiAlgumDadoFinanceiro(insumosPorGrupo[grupo.id])">
        Valor dos itens exibidos:
        <b>{{valorDosItensExibidos(insumosPorGrupo[grupo.id]) | currency:'BRL'}}</b>
        <span class="text-warning ml-2" *ngIf="possuiCustoDesconhecido(insumosPorGrupo[grupo.id])">
          <i class="k-icon k-i-warning"></i> existem itens sem custo conhecido
        </span>
      </div>

      <kendo-grid
        [loading]="carregando"
        (edit)="editarInsumo($event)"
        (pageChange)="mudouPaginacao($event)"
        (remove)="abraDialogRemoverInsumo($event)"
        [data]="insumosPorGrupo[grupo.id]"
        [class]="'gridProdutos'"   >
        <kendo-grid-messages
          pagerPage="Página"
          pagerOf="de"
          pagerItems="itens"
          noRecords="Sem insumos cadastrados"
          loading="Carregando"
          pagerItemsPerPage="ítems por página"
        >
        </kendo-grid-messages>

        <kendo-grid-column title="Codigo"  [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <span class="text-muted"><b>  {{dataItem.codigo || '-'}}</b></span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Nome"  >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <span><b>  {{dataItem.nome}}</b></span>

            <span class="badge badge-info ml-1" *ngIf="dataItem.beneficiado">beneficiado</span>
            <span class="badge badge-warning ml-1"
                  *ngIf="possuiDadosFinanceiros(dataItem) && !dataItem.estoque.custoConhecido">
              custo desconhecido
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Estoque atual"    [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">

            <ng-container *ngIf="dataItem.estoque && !dataItem.removido">
                 <span [ngClass]="{'text-success': dataItem.nivelEstoque > 1.5,
                              'text-warning': dataItem.nivelEstoque <= 1.5 ,
                              'text-danger': dataItem.nivelEstoque < 1 }" >
              <b> {{dataItem.estoqueAtual}} {{dataItem.unidadeMedida.sigla}}</b></span>
              <small class="d-block text-muted" *ngIf="possuiDadosFinanceiros(dataItem)">
                {{dataItem.estoque.quantidadeDisponivel}} disponível
              </small>

              <i class="k-icon k-i-list-bulleted cpointer text-blue ml-1" (click)="abraModalMovimentacoes(dataItem)"
                 style="    margin-top: -3px  " title="ver movimentações" kendoTooltip></i>
            </ng-container>


            <i class="k-icon k-i-exclamation-circle text-warning ml-1" kendoTooltip [title]=" dataItem.estoque.quantidadeReservada + ' reservados'"
               *ngIf="dataItem.estoque?.quantidadeReservada"></i>


            <span *ngIf="!dataItem.estoque || dataItem.removido">-</span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Custo médio" [width]="135"
                           *ngIf="possuiAlgumDadoFinanceiro(insumosPorGrupo[grupo.id])">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span *ngIf="possuiDadosFinanceiros(dataItem) && dataItem.estoque.custoConhecido">
              {{dataItem.estoque.custoMedio | currency:'BRL'}}
            </span>
            <span class="text-warning" *ngIf="possuiDadosFinanceiros(dataItem) && !dataItem.estoque.custoConhecido">
              Desconhecido
            </span>
            <span *ngIf="!possuiDadosFinanceiros(dataItem)">—</span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Valor físico" [width]="135"
                           *ngIf="possuiAlgumDadoFinanceiro(insumosPorGrupo[grupo.id])">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span *ngIf="possuiDadosFinanceiros(dataItem) && dataItem.estoque.valorFisico != null">
              {{dataItem.estoque.valorFisico | currency:'BRL'}}
            </span>
            <span *ngIf="!possuiDadosFinanceiros(dataItem) || dataItem.estoque.valorFisico == null">—</span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Estoque Minimo"    [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <span *ngIf="dataItem.estoque" [hidden]="dataItem.removido">
                       <b>{{dataItem.estoque.quantidadeMinima}} {{dataItem.unidadeMedida.sigla}}</b>
            </span>

            <span *ngIf="!dataItem.estoque || dataItem.removido">
                -
            </span>
          </ng-template>
        </kendo-grid-column>

        <!-- <kendo-grid-column title="Preço de custo"    [width]="150">
           <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
             {{dataItem.precoDeCusto | currency: "BRL"}}
           </ng-template>
         </kendo-grid-column> -->

        <kendo-grid-column title="Vínculos"    [width]="150"  media="(min-width: 1200px)">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <label class="text-blue cpointer" (click)="abraModalVincularInsumo(dataItem)" [hidden]="dataItem.removido || dataItem.beneficiado">
              {{dataItem.totalVinculos}}
              <i class="fas fa-box-open"></i>
            </label>

            <label *ngIf=" dataItem.beneficiado" class="text-muted">
              {{dataItem.totalVinculos}}
              <i class="fas fa-box-open"></i>
            </label>

          </ng-template>
        </kendo-grid-column>

        <kendo-grid-command-column title="" [width]="160" [class]="{'comandos': true}">
          <ng-template kendoGridCellTemplate let-isNew="isNew" let-insumo>

            <ng-container *ngIf="!insumo.removido">
              <button kendoGridEditCommand [primary]="true" (selectedChange)="editarInsumo(insumo)">
                <i class="fa fa-edit" kendoTooltip title="editar"></i>
              </button>

              <button   kendoGridRemoveCommand kendoTooltip ><i
                kendoTooltip [title]=" 'Remover insumo'"  class="fa fa-trash"></i>
              </button>
            </ng-container>

            <span class="badge badge-danger" *ngIf="insumo.removido">removido</span>

          </ng-template>

        </kendo-grid-command-column>

      </kendo-grid>
    </div>
  </div>
</ng-container>




<kendo-dialog title="Atenção!" *ngIf="abraDialogo" (close)="fecheRemover()" [minWidth]="250" [width]="450">
  <div *ngIf="itemSelecionado && !excluindo">
    <p style="margin: 30px; text-align: center;">Esta operação é irreversível. Tem certeza que deseja excluir o insumo
      "<strong>{{itemSelecionado.nome}}?</strong>"</p>
  </div>
  <div *ngIf="excluindo">
    <p style="margin: 30px; text-align: center;">Excluindo o insumo "<strong>{{itemSelecionado.nome}}"...</strong></p>
    <div class="k-i-loading ml-1 mr-1" style="font-size: 20px; padding-bottom: 20px  " ></div>
  </div>
  <div *ngIf="mensagemRemocao">
    <p style="margin: 30px; text-align: center;" class="text-danger">
      <b>{{mensagemRemocao}}</b>
    </p>
  </div>

  <div class="modal-footer" *ngIf="!excluindo">
    <button type="button" *ngIf="itemSelecionado" (click)="removaInsumo()" class="btn btn-primary waves-effect waves-light" >Remover</button>
    <button type="button" *ngIf="itemSelecionado" (click)="fecheRemover()" primary="true"  class="btn btn-light waves-effect">Cancelar</button>
    <button type="button" *ngIf="!itemSelecionado" (click)="fecheRemover()" class="btn btn-primary waves-effect waves-light" >Fechar</button>
  </div>
</kendo-dialog>
